import React from "react";
import Image1920x156 from "../img/thumb/photo-1920x156--2.jpg";
import {Config} from "../Config";

export default function Sitemap(prop) {

    let [newsCategory, setNewsCategory] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const newCategoryList = await getNewsCategory();
                setNewsCategory(newCategoryList);
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getNewsCategory() {
        const response = await fetch(Config.apiUrl +'newsCategory/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                <img src={Image1920x156} alt="" />
                <div className="container">
                    <p data-aos="fade-in"><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าแรก'}</a> / {prop.lang === 'en' ? 'Site Map':'แผนผังเว็บไซต์'}</p>
                    <h1 className="h2 textrow">
                        <span data-aos="fade-in">{prop.lang === 'en' ? 'Site Map':'แผนผังเว็บไซต์'}</span>
                    </h1>
                </div>
            </div>

            <div className="section bg-light">
                <div className="container">
                    <h2 className="text-center text-primary mb-sm-4 mb-3">{prop.lang === 'en' ? 'Site Map':'แผนผังเว็บไซต์'}</h2>
                    <div className="card-infos">
                        <ul>
                            <li><h6><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าหลัก'}</a></h6></li>
                            <li><h6>{prop.lang === 'en' ? 'About HTCR':'เกี่ยวกับ ศชวซ.'}</h6>
                                <ul className="mb-2">
                                    <li><a href={prop.lang === 'en' ? '/en/about':'/about'}>{prop.lang === 'en' ? 'About Us':'ความเป็นมา'}</a></li>
                                    <li><a href={prop.lang === 'en' ? '/en/mission':'/mission'}>{prop.lang === 'en' ? 'Mission':'วิสัยทัศน์/พันธกิจ'}</a></li>
                                    <li><a href={prop.lang === 'en' ? '/en/organization':'/organization'}>{prop.lang === 'en' ? 'Organization':'โครงสร้างคณะทำงาน ศชวซ.'}</a></li>
                                    <li><a href={prop.lang === 'en' ? '/en/authority':'/authority'}>{prop.lang === 'en' ? 'Authority':'อำนาจหน้าที่'}</a></li>
                                    <li><a href={prop.lang === 'en' ? '/en/plan':'/plan'}>{prop.lang === 'en' ? 'Plan':'แผนการดำเนินงาน'}</a></li>
                                </ul>

                            </li>

                            <li><h6>{prop.lang === 'en' ? 'News':'ข่าวสาร'}</h6>
                                <ul className="mb-2">
                                    {
                                        newsCategory !== null && newsCategory.count > 0 ?
                                            <>
                                                {
                                                    newsCategory.rows.map((row, index) => {
                                                        return (
                                                            <li key={index}><a href={prop.lang === 'en' ? '/en/news/category/' + row.slug:'/news/category/' + row.slug}>{prop.lang === 'en' ? row.title_en:row.title}</a></li>
                                                        )
                                                    })
                                                }
                                            </> : ''
                                    }
                                    <li><a href={prop.lang === 'en' ? '/en/announcement':'/announcement'}>{prop.lang === 'en' ? 'Announcement':'ประกาศ ศชวซ.'}</a></li>
                                    <li><a href={prop.lang === 'en' ? '/en/infographic':'/infographic'}>{prop.lang === 'en' ? 'Infographic':'Infographic'}</a></li>
                                </ul>
                            </li>

                            <li><a href={prop.lang === 'en' ? '/en/experts':'/experts'}><h6>{prop.lang === 'en' ? 'Expers':'ผู้เชี่ยวชาญ'}</h6></a></li>

                            <li><h6>{prop.lang === 'en' ? 'Publication documents':'เอกสารเผยแพร่'}</h6>
                                <ul className="mb-2">
                                    <li><a href={prop.lang === 'en' ? '/en/operating_results':'/operating_results'}>{prop.lang === 'en' ? 'Operating Results':'ผลลัพธ์การดำเนินงาน'}</a></li>
                                    <li><a href={prop.lang === 'en' ? '/en/member_results':'/member_results'}>{prop.lang === 'en' ? 'Member Results':'ผลงานของสมาชิก'}</a></li>
                                </ul>
                            </li>

                            <li><a href={prop.lang === 'en' ? '/en/partners':'/partners'}><h6>{prop.lang === 'en' ? 'Partners':'หน่วยงานเครือข่าย'}</h6></a></li>
                            <li><a href={prop.lang === 'en' ? '/en/contact':'/contact'}><h6>{prop.lang === 'en' ? 'Contact Us':'ติดต่อเรา'}</h6></a></li>
                            <li><a href={prop.lang === 'en' ? '/en/sitemap':'/sitemap'}><h6>{prop.lang === 'en' ? 'Site Map':'แผนผังเว็บไซต์'}</h6></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
} 